import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

export interface OrderButtonProps {
  items?: object;
  onclick?: (e?: React.MouseEvent) => void;
}

export const OrderButton: React.FC<OrderButtonProps> = ({ onclick }) => {
  const { t } = useTranslation();
  return (
    <Button
      type="primary"
      shape="round"
      className="food-order-button old-food-order-button"
      onClick={onclick}
    >
      {t('Order')}
    </Button>
  );
};

export const OldOrderButton: React.FC<OrderButtonProps> = ({ onclick }) => {
  const { t } = useTranslation();
  return (
    <Button
      type="primary"
      shape="round"
      className="food-order-button old-food-order-button"
      onClick={onclick}
    >
      {t('Order')}
    </Button>
  );
};

export const SaveButton: React.FC<OrderButtonProps> = ({ onclick }) => {
  const { t } = useTranslation();
  return (
    <Button
      type="primary"
      shape="round"
      className="food-order-button old-food-order-button"
      onClick={onclick}
    >
      {t('Save')}
    </Button>
  );
};
